import React, { useState } from 'react';
import LayoutHeader from '../../../../layout/LayoutHeader';
import { useLocation, useNavigate } from 'react-router';
import { MUSIC_PLATFORMS } from '../../../../constants/constants';
import MusicPlatform from '../../../../components/AddSection/Music/MusicPlatform';
import { useDispatch } from 'react-redux';
import { clearAlerts } from '../../../../store/alert/alertSlice';
import { addMusicToSectionThunk } from '../../../../store/addsection/addsectionThunk';
import DizeeButton from '../../../../components/DizeeComponent/DizeeButton';
import Check from '../../../../svg/Check';

export default function MusicPlatformPage() {
    const token = localStorage.getItem('dizeeToken');
    const [selectedPlatforms, setSelectedPlatforms] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [selectAll, setSelectAll] = useState(false);
    const { musicItem } = location.state;


    const handleTogglePlatform = (platform) => {
        setSelectedPlatforms(prevSelected =>
            prevSelected.includes(platform)
                ? prevSelected?.filter(item => item !== platform)
                : [...prevSelected, platform]
        );
    };

    const toggleAll = () => {
        setSelectedPlatforms(['spotify', 'apple_music', 'amazon', 'deezer', 'tidal', 'youtube']);
    }

    const toggleNone = () => {
        setSelectedPlatforms([]);
    }

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white'>Select a platform for preview</p>
                    <div className='flex gap-x-4'>
                        {/* <DizeeButton onClick={() => navigate('/add-section/music-playback', { state: { musicItem: musicItem, selectedPlatforms } })} label={'Next'} /> */}
                        <DizeeButton onClick={() => console.log(selectedPlatforms)} label={'Next'} />
                        <DizeeButton onClick={() => navigate(-1)} label={'Go back'} />
                    </div>
                </div>
                {
                    MUSIC_PLATFORMS.map((music, musicIndex) => (
                        musicItem.links?.filter((i) => i.source === music.value).map((item, itemIndex) => {
                            return (
                                <MusicPlatform
                                    txt={music.label}
                                    key={`${musicIndex}-${musicIndex}`} // Ensure unique keys for each music
                                    selected={selectedPlatforms.includes(music.value)}
                                    onSelect={() => handleTogglePlatform(music.value)}
                                />
                            );
                        })
                    ))
                }
                <div className='px-4 py-3 flex w-full items-center cursor-pointer' onClick={() => { setSelectAll(!selectAll); if (!selectAll) { toggleAll() } else { toggleNone() } }}>
                    <span className='text-white text-[12px] hover:text-[#4d4d4d] transition-colors duration-200'>{selectAll ? 'Clear selection' : 'Select all'}</span>
                </div>
            </div>
        </LayoutHeader>
    );
}
